import { useState } from 'react';
import { ChevronRight, PlayCircle, X } from 'lucide-react';
import { PROGRAM_DATA } from '../../data/programData';

export function IntroductionPage() {
  const [showWhyImportant, setShowWhyImportant] = useState(false);
  const { introduction } = PROGRAM_DATA;

  return (
    <div className="max-w-2xl mx-auto p-4 pb-24 lg:pb-8">
      <h1 className="text-2xl font-bold text-gray-900 mb-6">Introduction</h1>

      {/* Main Video */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden mb-6">
        <div className="aspect-video bg-gray-900">
          <iframe
            src={introduction.videoUrl}
            title="Introduction Video"
            className="w-full h-full"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      </div>

      {/* Content */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-4 mb-4">
        <div className="prose prose-sm max-w-none text-gray-700">
          {introduction.content.split('\n').map((paragraph, index) => (
            paragraph.trim() && <p key={index}>{paragraph.trim()}</p>
          ))}
        </div>
      </div>

      {/* Why is this so important? */}
      <button
        onClick={() => setShowWhyImportant(true)}
        className="w-full bg-white rounded-xl shadow-sm border border-gray-200 p-4 flex items-center justify-between hover:shadow-md transition-shadow"
      >
        <div className="flex items-center">
          <div className="h-10 w-10 rounded-full bg-primary/10 flex items-center justify-center mr-3">
            <PlayCircle className="h-5 w-5 text-primary" />
          </div>
          <span className="font-medium text-gray-900">Why is this so important?</span>
        </div>
        <ChevronRight className="h-5 w-5 text-gray-400" />
      </button>

      {/* Why Important Modal */}
      {showWhyImportant && (
        <div className="fixed inset-0 z-50 overflow-y-auto">
          <div 
            className="fixed inset-0 bg-black/70"
            onClick={() => setShowWhyImportant(false)}
          />
          
          <div className="flex min-h-full items-center justify-center p-4">
            <div className="relative bg-white rounded-xl shadow-xl w-full max-w-2xl overflow-hidden">
              <div className="flex items-center justify-between p-4 border-b">
                <h2 className="text-lg font-semibold">{introduction.whyImportant.title}</h2>
                <button
                  onClick={() => setShowWhyImportant(false)}
                  className="p-2 -mr-2 rounded-full hover:bg-gray-100"
                >
                  <X className="h-5 w-5 text-gray-500" />
                </button>
              </div>
              
              <div className="aspect-video bg-gray-900">
                <iframe
                  src={introduction.whyImportant.videoUrl}
                  title="Why is this so important?"
                  className="w-full h-full"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}